import React from "react";
import styles from "./Photos.module.css";
import dynamic from "next/dynamic";
const Loading = () => {
  return (
    <div className={styles.Photos}>
      <div className="w-full h-full relative"></div>
      <div className="w-full h-full relative"></div>
      <div className="w-full h-full relative"></div>
      <div className="w-full h-full relative"></div>
    </div>
  );
};
const Content = dynamic(() => import("./Photos/Content.js"), {
  loading: () => <Loading />,
});
const Photos = ({ data, page }) => {
  const Images = data;
  if (Images.length !== 0)
    return <Content Images={Images} page={page} styles={styles} />;
  else return <Loading />;
};
export default Photos;
